import * as React from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuthStore } from "@/stores/auth.store"
import { LoadingState } from "@/components/ui/loading-state"

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuthStore()

  if (isLoading) {
    return <LoadingState message="Checking authentication..." fullPage />
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />
  }

  return <Outlet />
}